import React from 'react';
import { useMemo } from 'react';
import tw from 'twin.macro';

import CartIcon from '@/assets/images/icons/CartIcon';
import DamageIcon from '@/assets/images/icons/DamageIcon';
import SecurityIcon from '@/assets/images/icons/SecurityIcon';
import SmsIcon from '@/assets/images/icons/SmsIcon';
import BlueCard from '@/assets/images/prepaid_blue.webp';
import GrayCard from '@/assets/images/prepaid_gray.webp';
import GreenCard from '@/assets/images/prepaid_green.webp';
import MintCard from '@/assets/images/prepaid_mint.webp';
import PinkCard from '@/assets/images/prepaid_pink.webp';
import socialMediaIcons from '@/assets/images/socialMediaIcons.svg';
import { BigTitle, BodyText, SubTitle } from '@/components';

function LandingPrepaidHowWorks() {
  const cardInfo = useMemo(
    () => [
      { icon: <CartIcon />, caption: 'Оплаты по всему миру и в интернете' },
      { icon: <SecurityIcon />, caption: 'Есть CVC и 3D-secure, работает в электронных кошельках' },
      { icon: <SmsIcon />, caption: 'Для открытия не нужны документы, достаточно номера телефона' },
      { icon: <DamageIcon />, caption: 'Пополнение, снятие денег или переводы с карты на карту невозможны' }
    ],
    []
  );
  return (
    <div>
      <BigTitle text={'Как работает карта'} twStyle={tw`sm:text-[34px] text-[24px] text-[#70FF6E] mb-10`} />
      <SubTitle
        text={
          <span>
            Предоплаченная карта открывается без документов и счёта. Ей можно оплатить покупки в магазине или подписку в
            интернете <img src={socialMediaIcons} alt='social media' tw='inline w-[150px]' />. Когда закончатся деньги —
            карта закроется автоматически.
          </span>
        }
        twStyle={tw`w-[90%]`}
      />
      <div tw='bg-[#444444] rounded-2xl xl:p-20 2xl:p-16 lg:p-16 md:p-8 p-5 flex sm:flex-row flex-col gap-5 w-full items-center justify-between mt-10 flex-wrap'>
        <img src={PinkCard} alt='' tw='2xl:w-[230px] xl:w-[230px]  lg:w-[230px] md:w-[200px] sm:w-[180px]' />
        <img src={GreenCard} alt='' tw='2xl:w-[230px] xl:w-[230px] lg:w-[230px] md:w-[200px] sm:w-[180px]' />
        <img src={BlueCard} alt='' tw='2xl:w-[230px] xl:w-[230px]  lg:w-[230px] md:w-[200px] sm:w-[180px]' />
        <div className='flex sm:flex-row flex-col w-full justify-center gap-10'>
          <img src={MintCard} alt='' tw='2xl:w-[230px] xl:w-[230px]  lg:w-[230px] md:w-[200px] sm:w-[180px]' />
          <img src={GrayCard} alt='' tw='2xl:w-[230px] xl:w-[230px]  lg:w-[230px] md:w-[200px] sm:w-[180px]' />
        </div>
      </div>
      <div tw='mt-5 grid sm:grid-cols-4 grid-cols-1 gap-5'>
        {cardInfo.map(card => (
          <div tw='bg-[#444444] rounded-[20px] p-5 pt-2 flex flex-col sm:gap-5 gap-0' key={card.caption}>
            <div tw='h-[80px] flex items-center '>{card.icon}</div>
            <BodyText text={card.caption} twStyle={tw``} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default LandingPrepaidHowWorks;
